module.exports = __webpack_public_path__ + "img/butterflyfish.2546bed4.png";